import { ProfileData } from '@lib/redux/slices/profileSlice';

/**
 * Filters profile data to include only safe, non-sensitive fields
 * @param rawProfileData Raw profile data from API
 * @returns Filtered profile data with only safe fields
 */
export function filterSafeProfileData(rawProfileData: any): ProfileData {
  return {
    name: rawProfileData?.name || `${rawProfileData?.first_name || ''} ${rawProfileData?.last_name || ''}`.trim() || 'User',
    phone: rawProfileData?.phone || rawProfileData?.contact_no || '',
    completionPercentage: rawProfileData?.completionPercentage || 0,
    avatar: rawProfileData?.avatar || '',
    email: rawProfileData?.email || '',
    contact_no: rawProfileData?.contact_no || rawProfileData?.phone || '',
    buying_period: rawProfileData?.buying_period || '',
    bookings: rawProfileData?.bookings || 0,
    is_onboarded: rawProfileData?.is_onboarded || false,
  };
} 